import React from 'react';
import CustomButton from './CustomButton';
import PetsIcon from '@mui/icons-material/Pets';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PublicIcon from '@mui/icons-material/Public';
import HubIcon from '@mui/icons-material/Hub';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Banho na rotina certa, sem dor de cabeça.
          </h1>

          <div className="hero-benefits">
            <div className="benefit-item">
              <PublicIcon className="benefit-icon" />
              <span>Plataforma completa para pets</span>
            </div>
            <div className="benefit-item">
              <LocalOfferIcon className="benefit-icon" />
              <span>Preço acessível</span>
            </div>
            <div className="benefit-item">
              <VerifiedUserIcon className="benefit-icon" />
              <span>Parceiros verificados</span>
            </div>
            <div className="benefit-item">
              <CalendarTodayIcon className="benefit-icon" />
              <span>Agenda fácil</span>
            </div>
            <div className="benefit-item">
              <PetsIcon className="benefit-icon" />
              <span>+15.000 pets atendidos</span>
            </div>
            <div className="benefit-item">
              <HubIcon className="benefit-icon" />
              <span>+200 parceiros na rede</span>
            </div>
          </div>

          <div className="hero-buttons">
            {/* <CustomButton
              customBackground="#FDF9F6"
              variant="none"
              sx={{
                padding: '14px 32px',
              }}
            >
              Baixe o app
            </CustomButton> */}
            <CustomButton
              variant="contained"
              sx={{
                padding: '14px 32px',
                fontSize: '15px'
              }}
            >
              <Link to="/cadastro-parceiro">
                Quero ser parceiro
              </Link>
            </CustomButton>
          </div>
        </div>

        <div className="hero-image">
          <img
            src="/images/cachorro-gota.png"
            alt="Cachorro sendo banhado"
            className="dog-image"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

